import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "./ui";

interface PageErrorProps {
  title: string;
  description: string;
  retry?: () => void;
  retryLabel?: string;
}

export function PageError({
  title,
  description,
  retry,
  retryLabel = "Tentar novamente",
}: PageErrorProps) {
  return (
    <section className="rounded-2xl border border-slate-200 bg-white p-8 text-center shadow-sm">
      <AlertCircle className="mx-auto text-slate-500" size={28} />
      <h1 className="mt-3 text-lg font-semibold text-slate-900">{title}</h1>
      <p className="mx-auto mt-1 max-w-md text-sm text-slate-600">
        {description}
      </p>
      {retry && (
        <Button variant="outline" className="mt-5" onClick={retry}>
          <RefreshCw size={16} />
          {retryLabel}
        </Button>
      )}
    </section>
  );
}
